import React from "react";
import ico from "../../../assets/fileicored.svg"
import s from "./PageFiles.module.css"
import {FileLeftLine} from "./FilesVeiw"
import {useState, useEffect} from "react";
import axios from "axios";
import {HrefsBeh1, WhiteButton} from "../PageInfo/PageInfo"
import {hrefsArr, PinkButton} from "./FilesNPD";
import ico2 from "../../../assets/link.ico";
import {FileLeftLineKDN} from "./FilesKDNNews";

const FilesAntiNarcotic = () => {
    const [respData, setData] = useState([])

    useEffect(() => {
        axios.get("https://fcprc.ru/api/behavior").then(
            res => {
                setData(res.data)
            })
    }, [])
    return <>
        <div className={s.filesLeftPage}>
            <div className={s.newHeader}>
                <h2>
                    Материалы антинаркотического содержания, разработанные в субъектах Российской Федерации
                </h2>

                <FileLeftLineKDN
                    text={respData[585]?.description} refers={respData[585]?.file}
                    ico={ico}/>
                <FileLeftLineKDN text={respData[100]?.description} refers={respData[100]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[214]?.description} refers={respData[214]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[16]?.description} refers={respData[16]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[216]?.description} refers={respData[216]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[217]?.description} refers={respData[217]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[218]?.description} refers={respData[218]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[219]?.description} refers={respData[219]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[220]?.description} refers={respData[220]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[221]?.description} refers={respData[221]?.file} ico={ico}/>
                <FileLeftLineKDN
                    text={"«Информационный буллинг. Совместные действия педагога-психолога и учителя в ситуации конфликта в классе» (Свердловская область)"}
                    refers={"https://www.youtube.com/watch?v=4zxZ8mkiH88"} ico={ico2}/>
                <FileLeftLineKDN text={respData[222]?.description} refers={respData[222]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[223]?.description} refers={respData[223]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[224]?.description} refers={respData[224]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[225]?.description} refers={respData[225]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[226]?.description} refers={respData[226]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[227]?.description} refers={respData[227]?.file} ico={ico}/>
                <FileLeftLineKDN text={respData[228]?.description} refers={respData[228]?.file} ico={ico}/>
            </div>
            <div style={{marginTop: "57px"}}>
                <HrefsBeh1 hrefsArr={hrefsArr}/>
                <PinkButton text="Материалы по профилактике ВИЧ/СПИДa" stylesheet={"pinkbutton"}
                            refs="/spec-materials-category/metodicheskie-materialy-po-profilaktike-vich-spida/"/>
                <PinkButton text="Инструкция по подготовке материалов по профилактике"
                            refs="fcprc.ru/media/media/behavior/07-6523-s-Pr.pdf"/>
                <WhiteButton text="Перейти к опросу родителей по информированности о профилактике ПАВ"
                             refs="http://опрос-родителей-о-пав.рф/"/>
                <WhiteButton text="Перейти к опросу молодёжи о ВИЧ" refs="http://опрос-молодежи-о-вич.рф/"/>
                <WhiteButton text="Перейти к опросу педагогов о профилактике ВИЧ-инфекции среди обучающихся"
                             refs="http://опрос-педагогов-о-вич.рф/"/>
            </div>
        </div>
    </>
}
export default FilesAntiNarcotic